module.exports = __webpack_public_path__ + "static/media/8.1c9e7ec3.jpg";